mutation Inertia_CreateParticipant($orderId: ID!, $name: String!) {
  createParticipant(input: { orderId: $orderId, name: $name }) {
    participant {
      id
      name
    }
    errors
  }
}